import React from 'react';
import { Icon } from '@/Components/Icon/Icon';
import { Icons } from '@/Static/IconsRes';
import Button from 'devextreme-react/button';
import styles from './ColumnChooseButton.scss';
import { DataGrid } from 'devextreme-react/data-grid';
import { useLocalization } from '@/Hooks';
import { Tooltip } from '@/Components/Tooltip/Tooltip';

type Props<TData extends object> = {
  innerGridRef: React.MutableRefObject<DataGrid<TData, keyof TData> | undefined>;
};

export const ColumnChooseButton = <TData extends object>({ innerGridRef }: Props<TData>): React.ReactElement => {
  const {
    common: {
      Actions: { ColumnChooser },
    },
  } = useLocalization();

  return (
    <Tooltip text={ColumnChooser}>
      <Button
        className={styles.button}
        onClick={() => {
          innerGridRef.current?.instance.showColumnChooser();
        }}
      >
        <Icon alt="clearFiltersIcon" src={Icons.ChooseColumn} className={styles.icon} />
      </Button>
    </Tooltip>
  );
};
